module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'SwitchButton ' + (_vm.icon ? 'has-icon' : 'no-icon'),
    style: (_vm.componentStyle)
  }, [(_vm.icon) ? _c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'before' && _vm.toggled) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.labelChecked))]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'before' && !_vm.toggled) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.labelUnchecked))]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'after') ? _c('span', {
    staticClass: "label",
    staticStyle: {
      "float": "right",
      "line-height": "26px",
      "margin-left": "10px",
      "text-transform": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelChecked))]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "vue-js-switch",
    class: {
      toggled: _vm.toggled, disabled: _vm.disabled
    }
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47895ee0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/SwitchButton.vue
// module id = 984
// module chunks = 0